import React from 'react';

const ctx = React.createContext();

const withTracking = (tracking) => {
  return (WrappedComponent) => {
    const HOC = (props) => (
      <ctx.Provider value={tracking}>
        <WrappedComponent {...{ ...props }} />
      </ctx.Provider>
    );
    HOC.displayName = `withTracking(${
      WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;
    return HOC;
  };
};

export { ctx, withTracking };
